import React from 'react'
import {useIntl} from 'react-intl'

// Components
import Seo from '@salesforce/retail-react-app/app/components/seo'
import StoreLocatorContent from '../../components/store-locator/index'

/* Providers */
import { StoreLocatorProvider } from '../../contexts/store-locator-context'
import { APIProvider } from '@vis.gl/react-google-maps';

/* Configs */
import { getConfig } from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../../utils/site-config'

const StoreLocator = () => {
    /* Configs */
    const intl = useIntl()
    const config = getConfig()
    const {site} = useMultiSite()
    const siteId = site?.id
    const GOOGLE_MAPS_API_KEY = getSiteEnvVarValue(config.app, 'GOOGLE_MAPS_API_KEY', siteId) || null

    const seoTitle = intl.formatMessage({
        id: 'store_locator.heading',
        defaultMessage: 'Store locator'
    })
    const seoDescription = intl.formatMessage({
        id: 'store_locator.seo.description',
        defaultMessage: 'Find a store near you. Get store hours, addresses and directions.'
    })

    return (
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
            <Seo title={seoTitle} description={seoDescription} />
            <StoreLocatorProvider>
                <StoreLocatorContent />
            </StoreLocatorProvider>
        </APIProvider>
    )
}

StoreLocator.getTemplateName = () => 'store-locator'

export default StoreLocator
